/**
 * @file Atom: Spinner
 * @description A simple, reusable loading spinner animation.
 */

import type React from 'react';

const Spinner: React.FC = () => (
  <div className="relative">
    <div className="animate-spin rounded-full h-16 w-16 border-4 border-transparent border-t-white"></div>
    <div
      className="absolute top-0 left-0 animate-spin rounded-full h-16 w-16 border-4 border-transparent border-b-white opacity-50"
      style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}
    ></div>
  </div>
);

export default Spinner;
